
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions/big-promotion",
      function () {
        return require("private-next-pages/promotions/big-promotion/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotions/big-promotion"])
      });
    }
  